import { z } from 'zod';

export const loginSchema = z.object({
  email: z.string().min(1, 'components.form.validation.required').email('components.form.validation.email'),
  password: z.string().min(1, 'components.form.validation.required'),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
